import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiConfigService } from '@fmnts/api';
import { catchError, map, Observable, throwError } from 'rxjs';

/**
 * Enum representing the result of sending an SMS
 */
export enum SendSmsStatus {
  /** Represents an successful request */
  Valid,
  /** Represents an request that was unsuccessful */
  Invalid,
  /** There was an error during transmission */
  NetworkError,
}

interface SendSmsResult {
  /** Status of the send SMS request */
  status: SendSmsStatus;
  /** Additional data */
  data?: any;
}

/**
 * Provides phone related services.
 */
@Injectable({
  providedIn: 'root',
})
export class PhoneService {
  private static readonly smsUrl = '/api/internal/sms/';

  constructor(
    private http: HttpClient,
    private apiConfig: ApiConfigService,
  ) {}

  /**
   * Validates the given `phoneNumber`.
   *
   * @param phoneNumber The phone number to validate
   * @param campaignId The campaign ID
   * @param locale The locale
   */
  sendSms(
    phoneNumber: string,
    campaignId: string | number,
    locale: string,
  ): Observable<SendSmsResult> {
    const url = this.apiConfig.buildApiUrl([PhoneService.smsUrl]);
    const data = {
      campaign_id: campaignId,
      lang: locale,
      to: phoneNumber,
    };

    return this.http.post(url, data).pipe(
      map((): SendSmsResult => ({ status: SendSmsStatus.Valid })),
      // The actual HTTP error response might be changed by a HTTP interceptor
      catchError((e: Record<'status', number> | HttpErrorResponse) =>
        throwError(() => ({
          status: [0].includes(e.status)
            ? SendSmsStatus.NetworkError
            : SendSmsStatus.Invalid,
          data: e,
        })),
      ),
    );
  }
}
